import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

import messages from '@/utils/messages'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnApproveFocusedInstitutional',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()

/**
 * ✅ SHOW APPROVE
 */
const showApproveButton = computed(() => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
  )
})

/**
 * ✅ SHOW REAPPROVE
 */
const showReapproveButton = computed(() => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
  )
})

/**
 * ✅ APROVAR
 */
const onApproveInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.approveInstitutional(id)

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro aprovado com sucesso!')
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao aprovar cadastro.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}

const onReapproveInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.reapproveInstitutional(id)

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro reaprovado com sucesso!')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao reaprovar cadastro.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (showApproveButton.value)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 0,
          id: "btn-approve-institutional",
          propBtnLabel: "Aprovar",
          propBtnFunction: onApproveInstitutional,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true),
    (showReapproveButton.value)
      ? (_openBlock(), _createBlock(_component_c_q_btn, {
          key: 1,
          id: "btn-reapprove-institutional",
          propBtnLabel: "Reaprovar",
          propBtnFunction: onReapproveInstitutional,
          propBtnTransparent: false,
          propBtnSize: _unref(EnumButtonSizes).LARGE_1
        }, null, 8, ["propBtnSize"]))
      : _createCommentVNode("", true)
  ]))
}
}

})